<header class="wp-header">
  <mat-toolbar class="header-toolbar" color="primary">

    <div class="menu-wrap">
      <a class="navbar-brand" routerLink="/welcome" aria-label="AquaTrade Home">
        <img src="/assets/img/logo-aqua-trade-pwsp-horizontal.svg"
             alt="AquaTrade Produced Water Sharing Portal"
             class="site-logo"
             decoding="async" />
        <span class="logo-title sr-only">AquaTrade</span>
      </a>
    </div>
    <div class="header-back">
      <a class="back-button nav-link" (click)="goBack()">
        <img src="/assets/img/icon.png"
             alt="Well Chron"
             class="logo-icon">
        <!--<span class="back-text">Well Chron</span>-->
      </a>
    </div>

  </mat-toolbar>
</header>

<div class="page-wrap">

  <main class="page-body">

    <div class="container login-page">
      <div class="row justify-content-center">

        <!-- HEADER TEXT -->
        <div class="col-12 col-md-8 col-lg-11">
          <div class="text-center mb-4">
            <h1 class="page-title">AquaTrade, The Produced Water Exchange</h1>
          </div>

          <!-- CARD -->
          <div class="card-wrap login-prompt mb-5">
            <div class="card-inner">

              <div class="card-header colored">
                <span class="tagline">
                  A Free and Open "Matchmaking Portal" for Produced Water
                </span>
              </div>

              <div class="card-body">

                <p>
                  As part of the U.S. Department of Energy’s produced water optimization initiative,
                  “Project PARETO”, the National Energy Technology Laboratory along with the Ground Water
                  Protection Council, has developed a novel produced water exchange portal prototype to
                  demonstrate the utility of this technology to prospective stakeholders.
                  This portal allows upstream and midstream organizations to declare when they have
                  excess produced water or need water, and it identifies and proposes mutually
                  beneficial “matches” that reduce the need for disposal and freshwater withdrawal.
                  This portal is intended to facilitate water exchange practices already adopted by the
                  industry on an ad-hoc basis, improving operational efficiency and reducing costs.
                </p>

                <a href="https://www.project-pareto.org/" target="_blank">
                  Powered by PARETO
                </a>

                <!-- ONE CONTINUE BUTTON -->
                <div class="continue-wrapper mt-5 text-center">
                  <a routerLink="/watersharing/welcome" class="btn-primary continue-btn">
                    Continue
                  </a>
                </div>

              </div>

            </div>
          </div>

        </div>

        <!-- LOGOS -->
        <div class="col-11 logos-container">

          <div class="row logos-row">

            <div class="logo-col">
              <a href="https://www.energy.gov/" target="_blank">
                <img src="/assets/img/logo-us-department-of-energy.png"
                     alt="US Department of Energy" />
              </a>
            </div>

            <div class="logo-col">
              <a href="https://www.netl.doe.gov/" target="_blank">
                <img src="/assets/img/logo-national-energy-technology-laboratory.png"
                     alt="National Energy Technology Laboratory" />
              </a>
            </div>

            <div class="logo-col">
              <a href="https://www.lbl.gov/" target="_blank">
                <img src="/assets/img/logo-berkeley-lab.png"
                     alt="Berkeley Lab" />
              </a>
            </div>

            <div class="logo-col">
              <a href="https://www.gwpc.org/" target="_blank">
                <img src="/assets/img/logo-groundwater-protection-council.png"
                     alt="Groundwater Protection Council" />
              </a>
            </div>

          </div>

        </div>

      </div>
    </div>

  </main>

</div>

